var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-text"},[_vm._v("\n  שלב "+_vm._s(_vm.currentStep)+" מתוך "+_vm._s(_vm.totalSteps)+"\n  "),_c('span',{staticClass:"ri-font-weight-bold"},[_vm._v(" · "+_vm._s(_vm.currentStepName))])])}
var staticRenderFns = []

export { render, staticRenderFns }